import { Modal, Spinner } from "react-bootstrap";

export default function LoadingModal() {
    return <Modal fullscreen show size="lg" animation>
        <div className="pd-40 centered-flex">
            <Spinner animation="border" />
        </div>
    </Modal>
}